module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.eed9aab5.woff";